// Components==============
import Avatar from 'components/UI/Avatar/Avatar';
import Dropdown from 'components/UI/Dropdown/Dropdown';
import NoContent from 'components/UI/NoContent/NoContent';
import ProgressGraph from 'components/UI/ProgressGraph/ProgressGraph';
import { motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useThemesWithProject } from 'hooks/useThemesWithProject';
import {
  StudentListEntity,
  useStudentList,
} from 'pages/Growth/Reflect/components/useStudentList';
import React, { useEffect, useState } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import '../StudentOverview.module.scss';
// =========================

const Graph = ({
  student,
  saveKey,
}: {
  student: StudentListEntity;
  saveKey: number;
}) => {
  const project = useRedux(
    (state) => state.project?.entities.byId[student.projectId]
  );

  const processes = useRedux((state) =>
    project?.process?.map((id) => state.process?.entities.byId[id])
  )?.sort((a, b) => parseInt(a?.order || '0') - parseInt(b?.order || '0'));

  const endPointActivities =
    processes?.filter(
      (p) => p?.process_type !== 'App\\Phase' && p?.process_id !== 3
    ) || [];

  const graphData = useRedux((state) => {
    const reflections = state.reflection?.entities.allIds.map(
      (id) => state.reflection?.entities.byId[id]
    );

    return endPointActivities
      .map(
        (e) =>
          reflections?.find(
            (r) =>
              r?.project_process_id === e?.id &&
              r?.created_by === student?.userId
          ) || 'filler'
      )
      .filter((e) => e);
  });

  const avatar = useRedux((state) => {
    const reflections = state.reflection?.entities.allIds.map(
      (id) => state.reflection?.entities.byId[id]
    );

    return reflections?.find((r) => r?.created_by === student.userId)?.user;
  });

  return (
    <div>
      <ProgressGraph
        data={graphData}
        topLeft={
          <div styleName="top">
            <Avatar user={avatar} />
            <p>{student.name}</p>
          </div>
        }
        project={project}
        saveKey={saveKey}
      />
    </div>
  );
};

export default function Progress() {
  const userId = useRedux((state) => state.authentication?.user?.id);

  const unfilteredThemesWithProject = useThemesWithProject();

  const themesWithProject = unfilteredThemesWithProject.filter((t) => {
    const studentCount = t?.allProjects?.filter((p) =>
      p.members
        .filter((m) => m.membership === 'teacher')
        .map((m) => m.user_id)
        .includes(userId || 0)
    );

    return studentCount && studentCount?.length > 0;
  });

  const [selected, setSelected] = useState(themesWithProject[0]?.name || '');

  const studentList = useStudentList(
    themesWithProject.find((t) => t?.name === selected)
  );

  const [saveKey, setSaveKey] = useState(0);
  useEffect(() => setSaveKey((prev) => prev + 1), [selected]);

  return (
    <NoContent
      page="judge"
      loading={false}
      hasContent={!!themesWithProject.length}
      decreasedHeight={70}
    >
      <motion.div {...framerFade} styleName="progress-wrapper">
        {!!themesWithProject.length && (
          <>
            <div styleName="selector">
              <Dropdown
                initialOptions={themesWithProject.map((t) => t?.name || '')}
                initialText={selected}
                selectedItem={selected}
                setSelectedItem={setSelected}
              />
            </div>
            <div styleName="graphs">
              {studentList.map((student) => (
                <Graph
                  key={student.userId}
                  student={student}
                  saveKey={saveKey}
                />
              ))}
            </div>
          </>
        )}
      </motion.div>
    </NoContent>
  );
}
